export enum ActionType {
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete'
}
